
  const __registry__ = require('../../../../../spiferack/client/index.js')
  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var styles = require('../../audit-logs.css');
var Link = require('@npm/spiferack/link');

var OrgFilterAction = function (_React$PureComponent) {
  _inherits(OrgFilterAction, _React$PureComponent);

  function OrgFilterAction() {
    _classCallCheck(this, OrgFilterAction);

    return _possibleConstructorReturn(this, (OrgFilterAction.__proto__ || Object.getPrototypeOf(OrgFilterAction)).apply(this, arguments));
  }

  _createClass(OrgFilterAction, [{
    key: 'render',
    value: function render() {
      var query = '?q=org:' + (this.props.filterText || this.props.text);
      return React.createElement(
        'b',
        null,
        React.createElement(
          Link,
          null,
          React.createElement(
            'a',
            { className: styles.filterActionText, href: query },
            this.props.text
          )
        )
      );
    }
  }]);

  return OrgFilterAction;
}(React.PureComponent);

var PackageFilterAction = function (_React$PureComponent2) {
  _inherits(PackageFilterAction, _React$PureComponent2);

  function PackageFilterAction() {
    _classCallCheck(this, PackageFilterAction);

    return _possibleConstructorReturn(this, (PackageFilterAction.__proto__ || Object.getPrototypeOf(PackageFilterAction)).apply(this, arguments));
  }

  _createClass(PackageFilterAction, [{
    key: 'render',
    value: function render() {
      var query = '?q=package:' + (this.props.filterText || this.props.text);
      return React.createElement(
        'b',
        null,
        React.createElement(
          Link,
          null,
          React.createElement(
            'a',
            { className: styles.filterActionText, href: query },
            this.props.text
          )
        )
      );
    }
  }]);

  return PackageFilterAction;
}(React.PureComponent);

var TokenFilterAction = function (_React$PureComponent3) {
  _inherits(TokenFilterAction, _React$PureComponent3);

  function TokenFilterAction() {
    _classCallCheck(this, TokenFilterAction);

    return _possibleConstructorReturn(this, (TokenFilterAction.__proto__ || Object.getPrototypeOf(TokenFilterAction)).apply(this, arguments));
  }

  _createClass(TokenFilterAction, [{
    key: 'render',
    value: function render() {
      var query = '?q=token:"' + (this.props.filterText || this.props.text) + '"';
      return React.createElement(
        'b',
        null,
        React.createElement(
          Link,
          null,
          React.createElement(
            'a',
            { className: styles.filterActionText, href: query },
            this.props.text
          )
        )
      );
    }
  }]);

  return TokenFilterAction;
}(React.PureComponent);

var EventFilterAction = function (_React$PureComponent4) {
  _inherits(EventFilterAction, _React$PureComponent4);

  function EventFilterAction() {
    _classCallCheck(this, EventFilterAction);

    return _possibleConstructorReturn(this, (EventFilterAction.__proto__ || Object.getPrototypeOf(EventFilterAction)).apply(this, arguments));
  }

  _createClass(EventFilterAction, [{
    key: 'render',
    value: function render() {
      var query = '?q=activity:' + (this.props.filterText || this.props.text);
      return React.createElement(
        Link,
        null,
        React.createElement(
          'a',
          { className: styles.listItemEventName, href: query },
          this.props.text
        )
      );
    }
  }]);

  return EventFilterAction;
}(React.PureComponent);

var IPFilterAction = function (_React$PureComponent5) {
  _inherits(IPFilterAction, _React$PureComponent5);

  function IPFilterAction() {
    _classCallCheck(this, IPFilterAction);

    return _possibleConstructorReturn(this, (IPFilterAction.__proto__ || Object.getPrototypeOf(IPFilterAction)).apply(this, arguments));
  }

  _createClass(IPFilterAction, [{
    key: 'render',
    value: function render() {
      var query = '?q=ip:' + (this.props.filterText || this.props.text);
      return React.createElement(
        Link,
        null,
        React.createElement(
          'a',
          { className: styles.listItemIPAddress, href: query },
          this.props.text
        )
      );
    }
  }]);

  return IPFilterAction;
}(React.PureComponent);

module.exports = {
  OrgFilterAction: OrgFilterAction,
  PackageFilterAction: PackageFilterAction,
  EventFilterAction: EventFilterAction,
  IPFilterAction: IPFilterAction,
  TokenFilterAction: TokenFilterAction
};
  let __hot__
  
  __registry__.register('audit-logs/actions/common/filterActions', module.exports, __hot__)
  